// extracted by css-extract-rspack-plugin
export default {"wrap":"EmailSignaturePreview_wrap__Hw9rs","content":"EmailSignaturePreview_content__ZWuDH"};